import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import TestimonialsPage from "./pages/TestimonialsPage";
import PortfolioPage from "./pages/PortfolioPage";
import ContactPage from "./pages/ContactPage";
import GetStartedPage from "./pages/GetStartedPage";
import ServiceCategoryPage from "./pages/ServiceCategoryPage";
import MutualFundsPage from "./pages/MutualFundsPage";
import "./styles/home.css";
import "./styles/review.css";
import "./styles/catalog.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = "APKfintech";
    const removeBadge = () => {
      const badge = document.getElementById("emergent-badge");
      if (badge) badge.remove();
    };
    removeBadge();
    const interval = setInterval(() => {
      removeBadge();
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          {({ setShowGetStartedModal }) => (
            <Routes>
              <Route path="/" element={<HomePage setShowGetStartedModal={setShowGetStartedModal} />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/services/:categorySlug" element={<ServiceCategoryPage />} />
              <Route path="/mutual-funds" element={<MutualFundsPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/get-started/:serviceSlug" element={<GetStartedPage />} />
            </Routes>
          )}
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
